import { render, staticRenderFns } from "./extractArticle.vue?vue&type=template&id=59c65c98&scoped=true"
import script from "./extractArticle.vue?vue&type=script&lang=ts"
export * from "./extractArticle.vue?vue&type=script&lang=ts"
import style0 from "./extractArticle.vue?vue&type=style&index=0&id=59c65c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c65c98",
  null
  
)

export default component.exports